import { render, staticRenderFns } from "./授权说明.vue?vue&type=template&id=53675152&scoped=true&"
import script from "./授权说明.vue?vue&type=script&lang=js&"
export * from "./授权说明.vue?vue&type=script&lang=js&"
import style0 from "./授权说明.vue?vue&type=style&index=0&id=53675152&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53675152",
  null
  
)

export default component.exports